export default {
  body: {
    label: 'Үндсэн хэсэг',
    info: `Та мессежийн агуулгыг форматлахын тулд **Markdown** синтаксыг ашиглаж болно (дэлгэрэнгүй мэдээллийг https://www.markdownguide.org хаягаас үзнэ үү).  
Зарим орлуулах хувьсагчид ч бас боломжтой:
- \`{{userTitleAndName}}\`: хэрэглэгчийн цол, нэрээр солигдоно (жишээ нь "Ноён Жон")
- \`{{userName}}\`: хэрэглэгчийн нэрээр солигдоно (жишээ нь "Жон")`,
  },
  dateSent: 'Илгээсэн огноо',
  dateValidUntil: 'Хүчинтэй огноо',
  deleteMessage: {
    confirmTitle: 'Та энэ мессежийг устгахдаа итгэлтэй байна уу?',
  },
  messageDeleted: 'Мессеж амжилттай устгагдлаа.',
  notificationType: {
    label: 'Мэдэгдлийн төрөл',
    email: 'Имэйл',
    push_notification: 'Апп доторх мэдэгдэл',
  },
  preview: 'Урьдчилан харах',
  sendMessage: {
    label: 'Мессеж илгээх',
    confirmTitle: 'Та энэ мессежийг илгээхдээ итгэлтэй байна уу?',
  },
  status: {
    label: 'Төлөв',
    draft: 'Ноорог',
    sent: 'Илгээсэн',
  },
  subject: 'Сэдэв',
  target: {
    label: 'Зорилтот',
    emailsExcluded: {
      label: 'Хассан имэйлүүд',
      placeholder: 'Хасах имэйл хаягаа оруулаад Нэмэх товчийг дарна уу',
    },
    emailsIncluded: {
      label: 'Нэмсэн имэйлүүд',
      placeholder: 'Нэмэх имэйл хаягаа оруулаад Нэмэх товчийг дарна уу',
    },
    userType: {
      label: 'Зорилтот хэрэглэгчийн төрөл',
      all: 'Бүх хэрэглэгчид',
      system_admins: 'Системийн администраторууд',
      survey_admins: 'Судалгааны админууд',
      survey_managers: 'Судалгааны менежерүүд',
      data_analysts: 'Өгөгдөл шинжээчид',
      data_cleaners: 'Өгөгдөл цэвэрлэгчид',
      data_editors: 'Өгөгдөл засварлагчид',
      individual: 'Бие даасан хэрэглэгчид',
    },
  },
}
